import { Box, Paper, Typography } from '@mui/material';
import { MergeType } from '@mui/icons-material';
import { useRecoilValue } from 'recoil';
import { userState } from 'state';

import { isAdmin } from 'lib/userHelpers';

// Phase 1: admin-only placeholder for the Merge & Dedupe surface. Automatic
// duplicate detection lands in Phase 5; until then this page establishes the
// route/nav entry and points admins at the per-row "Merge…" action.
export function MergeDedupePage() {
  const user = useRecoilValue(userState);

  if (!isAdmin(user)) {
    return (
      <Box sx={{ py: 4 }}>
        <Typography variant="h6">Not available</Typography>
        <Typography variant="body2" color="text.secondary">
          You don&apos;t have access to customer merge tooling.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h5" sx={{ mb: 0.5 }}>
        Merge &amp; Dedupe
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Find and resolve duplicate customer records.
      </Typography>

      <Paper
        variant="outlined"
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 1.5,
        }}
      >
        <MergeType sx={{ fontSize: 48, color: 'text.disabled' }} />
        <Typography variant="subtitle1">
          Automatic duplicate detection is coming soon
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 480 }}
        >
          We&apos;ll surface likely duplicate customers here for you to review
          and merge. In the meantime, you can merge any two customers directly
          from the <strong>Merge…</strong> action in a customer&apos;s row menu
          on the Customers page.
        </Typography>
      </Paper>
    </Box>
  );
}
